export default __webpack_public_path__ + "static/media/pl_employee.bcfe8380.png";